<!--
IMPORTANT:
This file is used only in the vue3 application
Any changes made here should be do in the vue2 file also
Any clarifications contact sai krishna

Vue2File : wwwroot\js\components\rotaionalspecialbanner\RotationalSpecialsContainer\RotationalSpecialsContainer.vue
-->
<template>
  <div class="slick-block pp-rotational-specials vehicle-specials-slider-box" :style="cssVars">
    <div class="" v-if="paymentdata.length">
      <div class="">
        <VSlickCarousel
          ref="slick"
          @afterChange="handleAfterChange"
          v-bind="paragonSlickOptions"
          @beforeChange="handleBeforeChange"
        >
          <template #prevArrow="arrowSlotProps">
            <div
              v-if="showArrows"
              @click="
                slickDirection = 'previous';
                arrowSlotProps.onClick();
              "
              :disabled="arrowSlotProps.disabled"
            >
              <em
                class="primaryicon-left-arrow slick-arrow"
                style="cursor: pointer; z-index: 1"
              ></em>
            </div>
          </template>
          <template #nextArrow="arrowSlotProps">
            <div
              v-if="showArrows"
              @click="
                slickDirection = 'next';
                arrowSlotProps.onClick();
              "
              :disabled="arrowSlotProps.disabled"
            >
              <em
                class="bgcolor-primary primaryicon-right-arrow slick-arrow"
                style="cursor: pointer; z-index: 1"
              ></em>
            </div>
          </template>
          <div
            v-for="(paymentoffer, index) in paymentdata"
            :key="index"
            class="py-5 vehicle-outer-wrapper rounded-box rotational-special-background-color paragon-special-slick-item px-3 px-md-0"
          >
            <div class="row justify-content-center">
              <div class="col-md-10">
                <div class="row align-items-center slot-swapping">
                  <div class="col-12 col-lg-6 rotational-special-font-primary-color">
                    <div
                      class="vehicle-specials-vehiclename color-black rotational-special-font-primary-color"
                    >
                      {{ paymentoffer.offertype }}
                      <span v-if="paymentoffer.offertype">a</span>
                      New {{ paymentoffer.modelYear }} <br />
                      {{ paymentoffer.divisionName }}
                      {{ getModelAndTrimName(paymentoffer) }}
                      {{ insertTradeMark(paymentoffer.styleNameWOTrim) }}
                    </div>
                    <div>
                      <div class="mt-2 pricing">
                        {{ paymentoffer.amountPreText }}
                      </div>
                      <div
                        v-if="paymentoffer.paymentOffer"
                        class="d-flex align-items-baseline terms"
                      >
                        <h3 class="font-weight-bold mb-0">
                          {{ paymentoffer.term }}
                        </h3>
                        <span class="ml-2">Months</span>
                      </div>
                      <div class="d-flex align-items-baseline pricing">
                        <h3
                          class="font-weight-bold mb-0"
                          :class="isGenesis ? 'first-letter-font' : ''"
                        >
                          {{ formatNumberInString(paymentoffer.offerText1) }}
                        </h3>
                        <span class="ml-2">{{
                          paymentoffer.paymentOffer
                            ? getPaymentOfferText(paymentoffer.offerText1)
                            : paymentoffer.offerText2
                        }}</span>
                      </div>
                      <p class="mb-0" v-html="formatOfferText(paymentoffer.offerText3)" />
                    </div>
                    <div class="mt-3">
                      <div v-if="paymentoffer.endDate" class="">
                        Expires {{ paymentoffer.endDate }}
                      </div>
                      <template v-if="!hideVINandStock">
                        <div
                          v-if="
                            paymentoffer.vin && paymentoffer.vin.trim() && paymentoffer.vin.length
                          "
                          class=""
                        >
                          VIN:{{ paymentoffer.vin }}
                        </div>
                      </template>
                    </div>

                    <div
                      v-if="enableVdvPanel && paymentoffer?.vdvEligible"
                      class="srp-vdv-play-banner cursor-pointer color-primary"
                      @click.prevent="
                        playVDV(paymentoffer.vehicleFullName.toLowerCase(), paymentoffer.vin)
                      "
                    >
                      <img :src="'/images/playbutton.png'" alt="Play button" />
                      Play Video
                    </div>

                    <div class="d-flex mt-5 align-items-center">
                      <div>
                        <a
                          class="no-hover px-5 py-2 mr-3 bgcolor-primary text-white rounded-buttons btn-websites button-primary d-inline-block"
                          :href="paymentoffer.vehicleFullName.toLowerCase()"
                          @click="logViewDetailsEvent()"
                          >View details</a
                        >
                      </div>
                      <a
                        v-if="!showDisclaimerOnLoad"
                        class="cursor-pointer no-hover border-black-bottom color-black bw-specials-text-disclaimer btn-websites button-text"
                        @click.prevent="openDisclaimer(paymentoffer.disclaimerText)"
                      >
                        <small class="color-black rotational-special-font-secondary-color"
                          >Disclosure</small
                        >
                      </a>
                    </div>
                    
                    <div class="mt-2">
                      <RotationalSpecialBannerCTA
                        v-show="buttonSettings.length"
                        template-class="paragon"
                        :payment-offer="paymentoffer"
                        @cta-action="
                          openLeadForm(
                            $event,
                            paymentoffer.offerID,
                            paymentoffer.vin,
                            paymentoffer.styleID,
                            paymentoffer.offerDesignID,
                            {
                              stockNumber: paymentoffer.stockNo,
                            }
                          )
                        "
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <evox-media-component
                      :styleid="paymentoffer.styleID"
                      :width="600"
                      :height="imageBannerHeight"
                      :imgurl="
                        paymentoffer.imageHandlerPath +
                        `&crop=true&angle=01&width=500&vehicletype=${paymentoffer.vehicleType}`
                      "
                      :imgclass="'img-fluid mx-auto'"
                      :evoxmediastyles="'max-width: 100%'"
                      :alt="`${paymentoffer.modelYear} ${paymentoffer.divisionName} ${paymentoffer.modelName} ${paymentoffer.trim}`"
                      :animation-type="specialRotatorAnimation"
                    />
                  </div>
                </div>
                <div class="pt-2" v-if="showDisclaimerOnLoad">
                  <h5 class="ft-20 my-2">Disclosure</h5>
                  <p class="ft-13 mt-2 px-0 text-justify" style="border-top: 1px solid #d4d4d4">
                    {{ paymentoffer.disclaimerText }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </VSlickCarousel>
      </div>
      <!-- <TestDrive-Form
        :opentestdrive="TestDriveForm"
        :offerid="offerid"
        :styleid="styleid"
        :vin="vin"
        :dealerurl="dealerurl"
        v-if="TestDriveForm"
        @hidemodal="TestDriveForm = false"
      ></TestDrive-Form>
      <GetOffer-Form
        :opengetoffer="GetOfferForm"
        :offerid="offerid"
        :styleid="styleid"
        :vin="vin"
        :dealerurl="''"
        :offercategoryid="'1'"
        :consumereventid="consumereventid"
        :offerdesignid="offerDesignID"
        v-if="GetOfferForm"
        @hidemodal="GetOfferForm = false"
      ></GetOffer-Form>
      <Contact-Form
        :opencontact="ContactForm"
        :offerid="offerid"
        :styleid="styleid"
        :vin="vin"
        :dealerurl="dealerurl"
        v-if="ContactForm"
        @hidemodal="ContactForm = false"
      ></Contact-Form>
      <text-modal
        :text="disclaimerText"
        v-if="opentextmodal"
        :title="'Disclosure'"
        @hidemodal="opentextmodal = false"
      ></text-modal>

      <cta-buttons-lead-form
        @onclose="buttontype = ''"
        :pagefrom="'homepagecta'"
        :buttontype="buttontype"
        :offerid="offerid"
        :vin="vin"
        :styleid="styleid"
        :offercategoryid="'1'"
        :offerdesignid="offerDesignID"
        v-if="buttontype"
      >
      </cta-buttons-lead-form> -->
    </div>
  </div>
</template>
<script type="text/javascript">
// import Thousandseperator from "../../filters/Thousandseperator";

import rotationalspecialbanners from "./RotationalSpecialsContainer/rotationalspecialbanners.js";
import { useThousandseperator } from "../../Composables/Thousandseperator/Thousandseperator.js";
import RotationalSpecialBannerCTA from "./RotationalSpecialBannerCTA.vue";
export default {
   name: "ParagonPrimaryRotationalSpecialBanner",
  mixins: [rotationalspecialbanners],
  data() {
    return {
      paragonSlickOptions: {
        groupsToShow: 1,
        groupsToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: "20px",
        autoplay: true,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              dots: true,
              arrows: true,
              groupsToShow: 1,
              groupsToScroll: 1,
              centerMode: true,
              centerPadding: "5%",
            },
          },
        ],
      },
    };
  },
  components: {
    RotationalSpecialBannerCTA,
  },
  computed: {
    cssVars() {
      return {
        "--bg-color": window.primaryColor,
      };
    },
  },
  mounted() {
    // this.primarySlickOptions.dots = true;
    // this.primarySlickOptions.dotsClass = "slick-dots pp-specials-slick";
    if (window.vehicleOfferRotationalDelay) {
      this.paragonSlickOptions.autoplay = true;
      this.paragonSlickOptions.autoplaySpeed = window.vehicleOfferRotationalDelay * 1000;
    }
  },
  methods: {
    formatOfferText(offerText) {
      const { Thousandseperator } = useThousandseperator();
      if (this.hideDownPaymentOnSpecials && offerText?.toLowerCase().includes("down payment")) {
        return "";
      }
      if (offerText && offerText.indexOf("$") >= 0) {
        let getValue = offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)
          ? offerText.match(/(-\d+|\d+)(,\d+)*(\.\d+)*/g)[0]
          : "";
        if (getValue) {
          let offerLabel = offerText.slice(offerText.indexOf(getValue) + getValue.length);
          offerLabel = offerLabel ? offerLabel.trim().toLowerCase() : offerLabel;
          if (this.isGenesis) {
            return `<h3 class="font-weight-bold mb-0 d-inline-block"><span style="font-size:50%">$</span>${Thousandseperator(
              getValue
            )}</h3>
          <span>${this.capitalizeFirstLetter(offerLabel)}</span>`;
          } else {
            return `<h3 class="font-weight-bold mb-0 d-inline-block">$${Thousandseperator(
              getValue
            )}</h3>
        <span>${this.capitalizeFirstLetter(offerLabel)}</span>`;
          }
        }
      }
      return offerText;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
<style>
.pp-rotational-specials .v-slick-carousel {
  position: relative;
}
.pp-rotational-specials .slick-list {
  padding: 0px 5% !important;
}
.pp-rotational-specials .slick-slide {
  margin: 0px 10px !important;
}
.pp-rotational-specials ul.v-slick-dots {
  display: flex !important;
  padding: 0px 13px;
  margin: 0px;
  text-align: center;
  position: absolute;
  top: 52%;
  right: -91%;
  flex-direction: column;
  transform: translateY(-50%);
}
/* .pp-rotational-specials ul.v-slick-dots li button{
  display: inline-block;
  width: 8px;
  margin: 5px 0px;
  height: 8px;
  border-radius: 50%;
  background: #cccccc;
} */
.pp-rotational-specials ul.v-slick-dots li button:before {
  font-size: 10px;
}
/* .pp-rotational-specials ul.v-slick-dots li.active {
  background-color: var(--bg-color);
} */
.pp-rotational-specials .v-slick-dots li.active button:before {
  opacity: 0.75;
  color: var(--bg-color);
}

.pp-rotational-specials ul.pp-specials-slick li button {
  display: none !important;
}
</style>
<style scoped>
.first-letter-font::first-letter {
  font-size: 50%;
}
.vehicle-specials-vehiclename {
  font-size: 2.2rem;
  line-height: 1.4;
}
.vehicle-outer-wrapper {
  background-color: #f5f5f5 !important;
}
._website_gemini .vehicle-outer-wrapper {
  background-color: #fff !important;
  border: 2px solid #f5f5f5;
}

.border-black-bottom {
  border-bottom: 1px solid #000;
}

.border-black {
  border: 1px solid #000;
}

@media (max-width: 991px) {
  .slot-swapping {
    flex-direction: column-reverse;
  }
  .vehicle-specials-vehiclename {
    font-size: 1.75rem;
  }
}

.srp-vdv-play-banner {
  display: flex;
  font-size: 14px;
  align-items: center;
  margin: 15px auto -20px;
}
.srp-vdv-play-banner img {
  filter: invert(1);
  margin-right: 4px;
  width: 4%;
}
.paragon-special-slick-item {
  margin: 0px 10px !important;
}
.v-slick-slider .primaryicon-left-arrow.slick-arrow {
  left: 2% !important;
}

.v-slick-slider .primaryicon-right-arrow.slick-arrow {
  right: 2% !important;
}
</style>
